import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import helpers from '../../../Utils/helpers';
import Tooltip, {TooltipContent, TooltipTrigger} from '../../Overlays/Tooltip';
import { InfoLabel } from '../../Badges/InfoLabel';
import useProductName from '../../../Hooks/useProductName';
import useModal from '../../../Hooks/useModal';
import {productId} from '../../../Constants/producs';
import modals from "../../../Constants/modals";

function CustomerInfoFlag({ type, title, onClick, tooltipText }) {
    const labelComponent = <InfoLabel type={type} title={title} onClick={onClick} />;

    if (!tooltipText) {
        return (
            <div className="d-inline-block position-relative infolabel ml-8">
                {labelComponent}
            </div>
        );
    }

    return (
        <div className="d-inline-block position-relative infolabel ml-8">
            <Tooltip>
                <TooltipTrigger>{labelComponent}</TooltipTrigger>
                <TooltipContent>{tooltipText}</TooltipContent>
            </Tooltip>
        </div>
    );
}

const CustomerInfoFlags = ({ customer, customerInfoFlags, customerInfoCounts, relatedCustomers, customerActions }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { translatedProductName } = useProductName();
    const { openModal } = useModal();
    const productName = translatedProductName(productId.tegner);

    const isAoCustomer = customer.vbCustomer ? helpers.isAoCustomer(customer.vbCustomer) : false;
    const isPartnerCustomer = customer.vbCustomer ? helpers.isPartnerCustomer(customer.vbCustomer) : false;

    const aoHasPartnerInfo = () => {
        return relatedCustomers && isAoCustomer && relatedCustomers.some(c => helpers.isPartnerCustomer(c));
    }

    const partnerHasAoInfo = () => {
        return relatedCustomers && isPartnerCustomer && relatedCustomers.some(c => helpers.isAoCustomer(c));
    }

    const flagTypeFromStatus = (status) => {
        switch (status) {
            case 0:
                return "info"
            case 1:
                return "success"
            case 2:
                return "warning "
            case 3:
                return "inactive-skynet"
            case 4:
                return "danger"
            default:
                return "";
        }
    }

    const onFlagClick = (e, flag) => {
        e.stopPropagation();
        e.preventDefault();

        switch (flag) {
            case "aopartner":
                dispatch(customerActions.setInternalLeadsEmailTemplate("AOPartnerLead"));
                return openModal(modals.InternalLeadEmail);
            case "2fa":
                return openModal(modals.Edit2Fa);
            default:
                return;
        }
    }

    return (<div className="pt-1">
        {customer.vonCustomer && <CustomerInfoFlag title={"2 F A"} type={!customer.vonCustomer?.useTotp ? "inactive-skynet" : "success"} onClick={(e) => onFlagClick(e, "2fa")}/> }
        {customerInfoFlags && customerInfoFlags.map((flag) => {
            return <CustomerInfoFlag key={flag.name} type={flagTypeFromStatus(flag.status)}
                                     title={t('maininfocontainer.' + flag.name)}
                                     onClick={flag.name === 'aopartner' && flag.status !== "success" ? (e) => onFlagClick(e, flag.name) : undefined}
                                     tooltipText={flag.tooltipText ? t(`customerinfoflags.${flag.tooltipText}`) : null}/>
        })
        }
        {isAoCustomer && <>
            {customerInfoCounts && (
                <CustomerInfoFlag
                    type={customerInfoCounts.numberOfEekonomiCollaborations > 0 ? "success" : "inactive-skynet"}
                    title={`Partnernivå ${customerInfoCounts.numberOfEekonomiCollaborations > 0 ? `${customerInfoCounts.partnerLevel} (${customerInfoCounts.numberOfEekonomiCollaborations})` : ""}`}
                    tooltipText={t('customerinfoflags.eekonomicollaborations', {productName, count: customerInfoCounts.numberOfEekonomiCollaborations})}
                />
            )}
            <CustomerInfoFlag type={aoHasPartnerInfo() ? "warning" : "inactive-skynet"} title={t('maininfocontainer.customeralsoreseller')}/>
            <CustomerInfoFlag type={partnerHasAoInfo() ? "warning" : "inactive-skynet"} title={t('maininfocontainer.customeralsoao')}/>
        </>
        }
    </div>)
}

export default CustomerInfoFlags;

